// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__groM_","Title":"Header_Title__VxhX0","BuyButton":"Header_BuyButton__r1AzW"};